import { map, pick } from 'ramda'
import { appendIf } from '@btime/helpers'
import { gql, useMutation } from '@apollo/client'

import { minicrudsClient } from '../../../../utils/apollo/api'
import { useCloseModal } from '../../../../components/modals/ModalsContext'

const MUTATION = gql`
  mutation UpsertMinicrud($input: MinicrudInput) {
    upsertMinicrud(input: $input) {
      id
    }
  }
`

const cleanRequest = pick(['id', 'name', 'entity'])

const validate = (form, setErrors) => {
  const errors = [...appendIf(!form.name, { path: ['name'], message: 'Campo obrigatório' })]

  setErrors(errors)
  return errors.length === 0
}

export const useSaveMinicrud = () => {
  const closeModal = useCloseModal()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Minicruds'], client: minicrudsClient })

  const handleRequest = (form, actions) => {
    const input = cleanRequest(form)
    const { setErrors } = actions
    const isValid = validate(form, setErrors)

    if (isValid) {
      return request({ variables: { input } }).then(resp => {
        if (!resp.errors) {
          closeModal()
        }
      })
    }
  }

  return [handleRequest, state]
}
